import { useCurrentTeam } from "libs/security/authorization/Permission";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import TeamService, { IAPITeam } from "pages/home/teams/services/TeamService";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Observable } from "rxjs";

export const useMemberListController = () => {
    // Get team from Redux or the active user's scoped team preference
    const { teamName: storedTeamName } = useCurrentTeam();
    const currentTeam = useSelector((state: any) =>
        state?.teamManager?.teams?.currentTeam?.teamName ?? storedTeamName
    );

    const { state, subscribe } = useAsyncAction(() =>
        TeamService.getTeamMembers(currentTeam) as Observable<IAPITeam[]>
    );

    const [prevTeam, setPrevTeam] = useState<string | null>(null);

    useEffect(() => {
        if (!subscribe || !currentTeam || !setPrevTeam) return;

        // Only run if either:
        // 1. This is the first time (prevTeam is null) OR
        // 2. The currentTeam (from redux or session) has changed from the previous value
        if (!prevTeam || prevTeam !== currentTeam) {
            subscribe();
            setPrevTeam(currentTeam);
        }
    }, [currentTeam, subscribe, prevTeam, setPrevTeam]);

    return {
        state,
        subscribe
    };
};